const firebaseConfig = {
    apiKey: "AIzaSyDc0dpIMrXEKX7h2Cx7cDQs2YKaOUTcA1A",
    authDomain: "ema-john-simple7.firebaseapp.com",
    databaseURL: "https://ema-john-simple7.firebaseio.com",
    projectId: "ema-john-simple7",
    storageBucket: "ema-john-simple7.appspot.com",
    messagingSenderId: "632136784727",
    appId: "1:632136784727:web:60afd128ff9e7195c73c12"
  };

  export default  firebaseConfig;